import React, { useEffect, useState } from "react";
import { Collapse, Skeleton } from "antd";
import PageContainer from "../../components/PageContainer";
import ContentSearch from "../blog/components/ContentSearch";
import { MinusCircleFilled, PlusCircleFilled } from "@ant-design/icons";
import { getFAQService } from "./faq.api";

const { Panel } = Collapse;

const text =
  "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.";

const FaqSearchResult = (props) => {
  const { title } = props;

  let searchParams = {
    targetWord: title,
    pageNumber: 0,
    pageSize: 20,
    sort: "ASC",
  };

  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([
    {
      id: "5f6c530b6850747ad6f27a11",
      subject: "subject1",
      question: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از؟",
      answer: text,
      categoryId: [],
      viewed: 0,
      rate: 0,
    },
    {
      id: "5f6c530b6850747ad6f27a12",
      subject: "subject2",
      question: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از؟",
      answer: text,
      categoryId: [],
      viewed: 0,
      rate: 0,
    },
    {
      id: "5f6c530b6850747ad6f27a13",
      subject: "subject3",
      question: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از؟",
      answer: text,
      categoryId: [],
      viewed: 0,
      rate: 0,
    },
  ]);

  useEffect(() => {
    setLoading(true);
    Object.assign(searchParams, { targetWord: title });

    getFAQService(searchParams)
      .then((res) => {
        setLoading(false);
        if (res.hasOwnProperty("data") && res.data.hasOwnProperty("content")) {
          setQuestions(res.data.content);
        }
      })
      .catch((err) => {
        console.error("خطایی در دریافت اطلاعات");
      });
    // eslint-disable-next-line
  }, [title]);

  return (
    <PageContainer
      classNames="faq"
      headerProps={{
        link: "/menu",
        right: "",
        content: "سوالات متداول",
        className: "home-header-holder transactions-header-holder",
        children: (
          <ContentSearch
            showFilterForm={false}
            allowClear={true}
            inputName="title"
          />
        ),
        tall: true,
      }}
    >
      <div className="faq-title">پرسش و پاسخ های متدوال:</div>
      <div className="faqs-wrapper">
        {loading ? (
          <>
            <Skeleton active={true} loading={loading} />
            <Skeleton active={true} loading={loading} />
            <Skeleton active={true} loading={loading} />
          </>
        ) : questions && questions.length > 0 ? (
          <Collapse
            defaultActiveKey={["1"]}
            ghost
            expandIcon={(panelProps) => {
              return panelProps.isActive ? (
                <MinusCircleFilled />
              ) : (
                <PlusCircleFilled />
              );
            }}
          >
            {questions.map((questionObj, i) => {
              return (
                <Panel
                  key={i + 1}
                  header={questionObj.question}
                  className="faq-panel"
                >
                  <p className="faq-description">{questionObj.answer}</p>
                </Panel>
              );
            })}
          </Collapse>
        ) : (
          "داده‌ای وجود ندارد"
        )}
      </div>
    </PageContainer>
  );
};

export default FaqSearchResult;
